import { queryOptions, useQuery } from '@tanstack/react-query';

import { customersApi } from '../api/customers-api';

import { customerKeys } from './customer-keys';

export function customerAddressesQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: customerKeys.addresses(storeId, id),
    queryFn: () => customersApi.addresses(storeId, id),
  });
}

export function useCustomerAddresses(storeId: string, id: string) {
  return useQuery(customerAddressesQueryOptions(storeId, id));
}
